import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            有料有真相
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            深度揭秘
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            最受关注的深度爆料内容，每一篇都经过多方交叉验证
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card, idx) => (
            <article
              key={card.id}
              className={`rounded-lg overflow-hidden bg-background-100 border border-background-300/50 transition-all duration-300 hover:border-primary-500/30 group cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    idx === 0 ? 'h-48 md:h-64' : 'h-44 md:h-48'
                  }`}
                  loading={idx < 3 ? undefined : 'lazy'}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent" />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-500/90 text-foreground-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                  {card.hot && (
                    <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500/90 text-background-900 whitespace-nowrap flex items-center gap-1">
                      <i className="ri-fire-line text-[10px]"></i>热门
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className={`font-bold text-foreground-50 group-hover:text-primary-400 transition-colors font-heading ${
                  idx === 0 ? 'text-lg md:text-xl' : 'text-sm md:text-base'
                }`}>
                  {card.title}
                </h3>
                <p className={`text-foreground-500 mt-2 leading-relaxed ${
                  idx === 0 ? 'text-sm' : 'text-xs md:text-sm'
                }`}>
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4">
                  <span className="text-xs text-foreground-600 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.date}
                  </span>
                  <span className="text-xs text-primary-400 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}